import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ImageCarousel from '../../compo/ImageCarousel';
import backimg4 from '../../img/categories/Gardening.png';
import backimg3 from '../../img/categories/KitchenProducts.png';
import backimg1 from '../../img/categories/PataStools.png';
import backimg2 from '../../img/categories/StorageOrganisers.png';
import video from '../../img/Family.png';
import './Home.css';

function Home() {
  const data = [
    { id: 1, name: "PataStools", img: backimg1 },
    { id: 2, name: "StorageOrganisers", img: backimg2 },
    { id: 3, name: "KitchenProducts", img: backimg3 },
    { id: 4, name: "Gardening", img: backimg4 },
  ];

  const [animationClass, setAnimationClass] = useState('');

  useEffect(() => {
    setAnimationClass('initial-animation');
  }, []);

  return (
    <>
      <div className={animationClass}>
        <section className='fade-in'>
          <ImageCarousel/>
        </section>

        <section className='strip'>
          <h3></h3>
          {/* <div className='para'> */}
            <p className='paraa'>
            We make every corner of Your house/office colourful with magic of Plastic, Our products are not just made with Plastic but are made with addition of Love
            </p>
          {/* </div> */}
        </section>

        <section className='about_section zoom-in'>
          <img src={video} alt="Video" />
          <div>
            <h1>About Pooja</h1>
            <p>
            
Plastic are fast replacing metals everywhere. POOJA PRODUCTS ever since it's inception has strived to provide furniture & households with superior quality plastic products that are not only strong and durable but also beauitiful and elegant. Every POOJA PRODUCTS is designed by experts and available in suitable sizes and a varity of colours. Our beautifully designed products make everyone feel that POOJA PRODUCTS are not just plastic Products but are really lifestyle products. In market crowed with plastic products ours is truly a brand. A brand that does not just supply quality products but caters to all needs and requirements. We have a wide range of products, from moulded furniture to household items, from kitchen containers to fancy articles and even garden planters, to cater to every household requirement.
            </p>
            <p><Link to='/about' style={{textDecoration:"none"}}>Read More</Link></p>
          </div>
        </section>

        <section className='why_section fade-in-left'>
          <div className='why_main'>
            <div className='item_two'>
              <h1>Quality Policy / Processes
              </h1>
              <div className='item'>
                <ul>
                  <li><FontAwesomeIcon icon={faArrowRight} />Committed to ethical and sincere dealings.</li>
                  <li><FontAwesomeIcon icon={faArrowRight} />Dedicated to maintaining supreme grade quality standards across an extensive product portfolio.</li>
                  <li><FontAwesomeIcon icon={faArrowRight} />Implements a well-defined quality management strategy:</li>
                  <li><FontAwesomeIcon icon={faArrowRight} />Stringent quality checks at every stage of the manufacturing process.</li>
                  <li><FontAwesomeIcon icon={faArrowRight} />Utilizes cutting-edge technology for raw material processing.</li>
                </ul>
                <div className='hello'></div>
              </div>
            </div>
          </div>
        </section>

        <section className='products fade-in-up'>
          <h1>A Wide Range Of Products</h1>
          {/* <p>~ some of our best sellers ~</p> */}
          
          <div className="card-container">
            {data.map((item) => (
              <Link to="product" >
              <div key={item.id} className="card zoom-in">
                <div className="card-image">
                  <img src={item.img} alt={item.name} />
                  <div className="card-text">
                    <h3>{item.name}</h3>
                  </div>
                </div>
              </div>
              </Link>
            ))}
          </div>
        </section>

        <section>
          <div className='uper_footer bounce-in'>
            <div>
              <h2>WANT TO KNOW MORE ABOUT US?</h2>
              <p>Contact us now to know the benefits of our products</p>
            </div>
            <div className='footer_button'>

              <button><Link to="/contact">CONTACT US</Link></button>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;
